import * as React from "react";
import styled from "styled-components";
import { useSelect } from "@hubper/theme";

import { Container } from "../InputContainer";

import { inputResetStyle } from "../TextInput";
import Icon from "../Icon";

import mergeStyles from "../../util/mergeStyles";
import mergeHandlers from "../../util/mergeHandlers";
import composeRefs from "../../util/composeRefs";

const HEIGHT = 36;

const Input = styled.input`
  ${inputResetStyle}
  flex: 1;
  height: 100%;
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  disabled?: boolean;
  value?: string;
  stretch?: boolean;
  dashed?: boolean;
  containerRef?: any;
} & React.HTMLAttributes<HTMLInputElement>;

function FilterInput(
  {
    style,
    className,
    disabled,
    value,
    containerRef,
    dashed,
    stretch,
    ...rest
  }: Props,
  ref: any
) {
  const [hasFocus, setFocus] = React.useState(false);
  const inputRef = React.useRef<HTMLInputElement>(null);
  const { space } = useSelect();

  return (
    <Container
      focus={hasFocus || Boolean(value!)}
      ref={containerRef}
      style={mergeStyles(style, {
        height: HEIGHT,
        paddingLeft: space(2),
        paddingRight: space(2)
      })}
      className={className}
      stretch={stretch}
      disabled={disabled}
      dashed={dashed}
      onClick={(evt: any) => {
        if (evt.target !== inputRef.current!) {
          inputRef.current!.focus();
        }
      }}
    >
      <Input
        {...rest}
        value={value}
        ref={composeRefs(inputRef, ref)}
        onFocus={mergeHandlers(rest.onFocus, () => setFocus(true))}
        onBlur={mergeHandlers(rest.onBlur, () => setFocus(false))}
      />
      <Icon name="search" c={["grey", hasFocus || value! ? 5 : 2]} />
    </Container>
  );
}

export default React.forwardRef(FilterInput);
